import React from 'react';
import { Table, Column, Cell } from 'fixed-data-table';

class XpressTemplateAppliedModal extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    let templateName = this.props.template.name;
    let kiosks = this.props.kiosks;
    let onClick = this.props.onClickOk;

    return (
      <div style={{ width: 400 }}>
        <h1>Done applying {templateName} to the folloiwng kiosks:</h1>
        <Table rowsCount={kiosks.length} rowHeight={50} headerHeight={50} width={400} height={400}>
          <Column
            header={<Cell>Kiosk</Cell>}
            cell={(props) => (
              <Cell {...props} className='main-cell' style={{ color: 'black' }}>
                {kiosks[props.rowIndex].kiosk}
              </Cell>
            )}
            fixed={true}
            height={100}
            width={400}
            align='center'
          />
        </Table>

        <div className='modalFooter pure-g'>
          <div className='pure-u-1-4' style={{ width: 400 }}>
            <button
              className='pure-button button-regular button-aux'
              onClick={onClick}
              style={{ background: '#216887' }}
            >
              Ok
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default XpressTemplateAppliedModal;



// WEBPACK FOOTER //
// ./src/components/XpressTemplateAppliedModal.js